module.exports = __webpack_public_path__ + "img/4-detail.d82a5bdb.jpg";